type LaptopType = {
  active?: boolean;
  className?: string;
};

const Laptop = ({ active, className = '' }: LaptopType) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={`${active ? 'white' : '#393939'} `}
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M23.75 20.375H0.75V19.125H23.75V20.375ZM21.6865 3.625C22.1872 3.625 22.5981 4.01901 22.624 4.51367L22.625 4.56348V17.4365C22.625 17.9371 22.2308 18.3481 21.7363 18.374L21.6865 18.375H2.81348C2.31266 18.375 1.90195 17.9806 1.87598 17.4863L1.875 17.4365V4.56348C1.875 4.0624 2.26938 3.65189 2.76367 3.62598L2.81348 3.625H21.6865ZM3.125 17.125H21.375V4.875H3.125V17.125Z"
      fill="black"
    />
  </svg>
);
export default Laptop;
